/* eslint-disable space-before-function-paren */
import { checkinApi } from '@/services/api/httpClient';
import { actionsModules } from './actions-modules';

const actions = {
  async checkAndSetT2Flow({ getters, commit, dispatch }) {
    const medicalOrders = getters.getCurrentAdmissionState.data.medicalOrders;
    if (medicalOrders && medicalOrders.length && medicalOrders[0].exams.length) {
      const flowConfig = await dispatch('getFlowConfig');

      commit('global/SET_T2_FLOW', flowConfig.skipServiceDeskFlow);
      commit('global/SET_PAYMENT_BYPASS', flowConfig.isAdmissionStartedPaymentButNotFinished);
      commit('global/SET_ONLINE_PAYMENT_ENABLED', flowConfig.onlinePayment);
      commit('global/SET_ADMISSION_AUTHORIZATION', flowConfig.skipServiceDeskHealthInsuranceFlow);

      return flowConfig;
    }
    return false;
  },

  async getEndFlowMessage({ getters }) {
    const admissionId = getters.getCurrentAdmissionState.data.id;
    const url = `/admission/${admissionId}/end-message`;
    try {
      const resp = await checkinApi().get(url);
      if (resp.data) {
        return resp.data.endFlowMessage;
      }
      return '';
    } catch (error) {
      return '';
    }
  },

  async getFlowConfig({ commit, getters }) {
    const admissionId = getters.getCurrentAdmissionState.data.id;
    const url = `/admission/${admissionId}/flow`;
    try {
      const resp = await checkinApi().get(url);
      const { data } = resp;
      commit('global/SET_ADMISSION_FLOWS', data);
      return data;
    } catch (error) {
      return false;
    }
  },

  getIsIncompany({ commit, getters }) {
    const INCOMPANY_TYPE_ID = 11;
    const unitTypeId = getters.selectedUnit.idTipoUnidade;

    if (unitTypeId === INCOMPANY_TYPE_ID) {
      commit('global/SET_IS_INCOMPANY_FLOW', true);
      return true;
    }

    commit('global/SET_IS_INCOMPANY_FLOW', false);
    return false;
  },

  async getUnitDocsSurveys({ getters, commit }, params) {
    const admissionId = getters.getCurrentAdmissionState.data.id;

    const url = `/admission/${admissionId}/survey`;
    try {
      const resp = await checkinApi().get(url);
      return resp.data;
    } catch (error) {
      return null;
    }
  },

  async setAdmissionNotElegible({ getters, commit }) {
    commit('global/SET_T2_FLOW', false);
    const admissionId = getters.getCurrentAdmissionState.data.id;

    const url = `/admission/${admissionId}/not-eligible`;
    try {
      const resp = await checkinApi().get(url);
      return resp.data;
    } catch (error) {
      return false;
    }
  },

  async getAllowConfirmArrival({ getters }) {
    const admissionId = getters.getCurrentAdmissionState.data.id;

    const url = `/admission/${admissionId}/medical-orders/allow-confirm-arrival`;
    try {
      const result = await checkinApi().get(url);
      return result.data;
    } catch (error) {
      return false;
    }
  },
};

export default { ...actions, ...actionsModules };
